import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ModalCloseStrategy, SdModalOptions } from '@shared/v2';
import { SdvorClickOutsideDirective } from '../../../../directives';
import { SdvorIconComponent } from '../../../icon';

@Component({
  selector: 'sd-modal-compact',
  templateUrl: './modal-compact.component.html',
  styleUrls: ['./modal-compact.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorIconComponent, SdvorClickOutsideDirective],
})
export class SdvorModalCompactComponent {
  options = input.required<SdModalOptions>();
  closed = output<void>();

  onClickOutside(): void {
    if (this.options().closeStrategy !== ModalCloseStrategy.Outside || this.options().ignoreOutsideClick) {
      return;
    }

    this.onClose();
  }

  onClose(): void {
    this.closed.emit();
  }
}
